<!-- <mat-tab-group #tabs class="mt-5">
    <mat-tab label="Select Availability"> -->
<table mat-table [dataSource]="dataSource" class="w-100" #timeRangeTable>

    <ng-container matColumnDef="Mon">
        <th mat-header-cell *matHeaderCellDef> Mon </th>
        <td mat-cell *matCellDef="let element" class="{{element.class}}">

            <button id="Mon-{{element.hours}}" mat-button
                (click)="buttonClicked('Mon', element.hours, $event)">{{element.time}}</button>
            <a class="res-circle">
                <div class="circle-txt">x</div>
            </a>
        </td>
    </ng-container>
    <ng-container matColumnDef="Tue">
        <th mat-header-cell *matHeaderCellDef> Tue </th>
        <td mat-cell *matCellDef="let element">

            <button id="Tue-{{element.hours}}" mat-button
                (click)="buttonClicked('Tue', element.hours,$event)">{{element.time}}</button>
            <a class=" res-circle">
                <div class="circle-txt">x</div>
            </a>
        </td>
    </ng-container>
    <ng-container matColumnDef="Wed">
        <th mat-header-cell *matHeaderCellDef> Wed </th>
        <td mat-cell *matCellDef="let element">

            <button id="Wed-{{element.hours}}" mat-button
                (click)="buttonClicked('Wed', element.hours, $event)">{{element.time}}</button>
            <a class=" res-circle">
                <div class="circle-txt">x</div>
            </a>
        </td>
    </ng-container>
    <ng-container matColumnDef="Thu">
        <th mat-header-cell *matHeaderCellDef> Thu </th>
        <td mat-cell *matCellDef="let element">

            <button id="Thu-{{element.hours}}" mat-button
                (click)="buttonClicked('Thu', element.hours, $event)">{{element.time}}</button>
            <a class=" res-circle">
                <div class="circle-txt">x</div>
            </a>
        </td>
    </ng-container>
    <ng-container matColumnDef="Fri">
        <th mat-header-cell *matHeaderCellDef> Fri </th>
        <td mat-cell *matCellDef="let element">

            <button id="Fri-{{element.hours}}" mat-button
                (click)="buttonClicked('Fri', element.hours, $event)">{{element.time}}</button>
            <a class=" res-circle">
                <div class="circle-txt">x</div>
            </a>
        </td>
    </ng-container>
    <ng-container matColumnDef="Sat">
        <th mat-header-cell *matHeaderCellDef> Sat </th>
        <td mat-cell *matCellDef="let element">
            <button id="Sat-{{element.hours}}" mat-button
                (click)="buttonClicked('Sat', element.hours, $event)">{{element.time}}</button>
            <a class=" res-circle">
                <div class="circle-txt">x</div>
            </a>
        </td>
    </ng-container>
    <ng-container matColumnDef="Sun">
        <th mat-header-cell *matHeaderCellDef> Sun </th>
        <td mat-cell *matCellDef="let element">

            <button id="Sun-{{element.hours}}" mat-button
                (click)="buttonClicked('Sun', element.hours, $event)">{{element.time}}</button>
            <a class=" res-circle">
                <div class="circle-txt">x</div>
            </a>
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="timeRangeDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: timeRangeDisplayedColumns;"></tr>
</table>

<!-- </mat-tab>
    <mat-tab label="Select Specfic Days">
        <div class="body table-responsive">
            <div class="row">
                <div class="d-flex justify-content-center align-items-center ">
                    <a href="javascript: void(0);" (click)="decrementDateRange()"> <i
                            class="material-icons">keyboard_arrow_left</i></a><span id=dateHeader>{{rangeStartDate |
                        date: 'MM/dd/yyyy'}} -
                        {{rangeEndDate | date: 'MM/dd/yyyy'}}</span><a href="javascript: void(0);"
                        (click)="incrementDateRange()">
                        <i class="material-icons">keyboard_arrow_right</i></a>
                </div>
            </div>
            <table mat-table [dataSource]="dataSource" class="w-100">
                
<ng-container matColumnDef="Time">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let element">
        {{element.time}}
    </td>
</ng-container>

<ng-container matColumnDef="Mon">
    <th mat-header-cell *matHeaderCellDef> Mon </th>
    <td mat-cell *matCellDef="let element">
        <mat-checkbox (change)="datePicked($event.checked, element.mon )"
            disabled="{{element.mon.getTime() < today.getTime()}}"></mat-checkbox>
    </td>
</ng-container>

<ng-container matColumnDef="Tue">
    <th mat-header-cell *matHeaderCellDef> Tue </th>
    <td mat-cell *matCellDef="let element">
        <mat-checkbox (change)="datePicked($event.checked, element.tue )"
            disabled="{{element.tue.getTime() < today.getTime()}}"></mat-checkbox>
    </td>
</ng-container>

<ng-container matColumnDef="Wed">
    <th mat-header-cell *matHeaderCellDef> Wed </th>
    <td mat-cell *matCellDef="let element">
        <mat-checkbox (change)="datePicked($event.checked, element.wed )"
            disabled="{{element.wed.getTime() < today.getTime()}}"></mat-checkbox>
    </td>
</ng-container>

<ng-container matColumnDef="Thu">
    <th mat-header-cell *matHeaderCellDef> Thu </th>
    <td mat-cell *matCellDef="let element">
        <mat-checkbox (change)="datePicked($event.checked, element.thu )"
            disabled="{{element.thu.getTime() < today.getTime()}}"></mat-checkbox>
    </td>
</ng-container>
<ng-container matColumnDef="Fri">
    <th mat-header-cell *matHeaderCellDef> Fri </th>
    <td mat-cell *matCellDef="let element">
        <mat-checkbox (change)="datePicked($event.checked, element.fri )"
            disabled="{{element.fri.getTime() < today.getTime()}}"></mat-checkbox>
    </td>
</ng-container>
<ng-container matColumnDef="Sat">
    <th mat-header-cell *matHeaderCellDef> Sat </th>
    <td mat-cell *matCellDef="let element">
        <mat-checkbox (change)="datePicked($event.checked, element.sat )"
            disabled="{{element.sat.getTime() < today.getTime()}}">
        </mat-checkbox>
    </td>
</ng-container>
<ng-container matColumnDef="Sun">
    <th mat-header-cell *matHeaderCellDef> Sun </th>
    <td mat-cell *matCellDef="let element">
        <mat-checkbox (change)="datePicked($event.checked, element.sun )"
            disabled="{{element.sun.getTime() < today.getTime()}}"></mat-checkbox>
    </td>
</ng-container>
<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>
</mat-tab>
</mat-tab-group> -->